import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import WorkforceCard from "components/WorkforceCard/WorkforceCard";

import { getLoggedInUserDetailsFromLocalStorage } from "helpers";
import { EmployeePeers } from "store/actions/EmployeePeers";

import "./EmployeePeers.css";

function EmployeePeersCom() {
  const dispatch = useDispatch();

  const peers = useSelector((state) => state.EmployeePeers);

  useEffect(() => {
    const { userId } = getLoggedInUserDetailsFromLocalStorage();
    const url = `employee/${userId}/peers`;

    const employeePeersEndPoint = {
      url,
      isFlagTeamManagement: false,
    };

    dispatch(EmployeePeers(employeePeersEndPoint));
  }, []);

  return (
    <div
      className="ep-peers-list"
      style={{
        justifyContent: peers?.peers?.count >= 4 ? "space-between" : "normal",
      }}
    >
      {peers?.peers?.count ? (
        peers?.peers?.rows?.slice(0, 4).map((peer) => {
          return <WorkforceCard key={peer?.employeeId} data={peer} isEmployee />;
        })
      ) : (
        <div
          style={{
            background: "var(--color-primitives-primary-50)",
            padding: "80px",
            width: "100%",
            borderRadius: "24px",
            border: "1px dashed #C0C2FE",
          }}
          id="no-peers-found"
        >
          <p
            style={{
              margin: "auto",
              textAlignLast: "center",
              width: "100%",
            }}
          >
            {peers?.peers?.message || "No Peers found"}
          </p>
        </div>
      )}
    </div>
  );
}

export default EmployeePeersCom;
